import { Query, QueryForm } from '../types/Query';
import { toCamelCase, toSnakeCase } from '../utils/caseConverter';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

export const fetchQueries = (customerId? : number) => {
  const queryURI = customerId ? `/api/queries/customer/${customerId}` : '/api/queries'
  return fetch(`${API_BASE_URL}${queryURI}`, {
            headers: { 'Authorization': `Bearer ${localStorage.getItem('token')}` }
         }).then(res => res.json()).then(data => toCamelCase(data));
};

export async function createQuery(data: QueryForm): Promise<Query> {
  const res = await fetch(`${API_BASE_URL}/api/queries`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${localStorage.getItem('token')}` },
    body: JSON.stringify(toSnakeCase(data)),
  });

  if (!res.ok) {
    const errorText = await res.text();
    throw new Error(`Failed to create query: ${errorText}`);
  }

  return res.json();
}

export async function assignQuery(queryId: number, userId: number): Promise<{ id: number }> {
  const res = await fetch(`${API_BASE_URL}/api/queries/${queryId}/assign`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${localStorage.getItem('token')}` },
    body: JSON.stringify({ "assigned_to": userId })
  });

  if (!res.ok) {
    const errorText = await res.text();
    throw new Error(`Failed to assign query: ${errorText}`);
  }

  return res.json();
}

export async function updateQueryStatus(queryId: number, status: string): Promise<Query> {
  const res = await fetch(`${API_BASE_URL}/api/queries/${queryId}`, {
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${localStorage.getItem('token')}` },
    body: JSON.stringify({ status }),
  });

  if (!res.ok) {
    const errorText = await res.text();
    throw new Error(`Failed to update query: ${errorText}`);
  }

  const data = await res.json();
  return toCamelCase(data);
}

export async function fetchQueryById(queryId: number): Promise<Query> {
  const res = await fetch(`${API_BASE_URL}/api/queries/${queryId}`, {
    headers: { 'Authorization': `Bearer ${localStorage.getItem('token')}` },
  });
  if (!res.ok) {
    const errorText = await res.text();
    throw new Error(`Failed to fetch query: ${errorText}`);
  }
  const data = await res.json();
  return toCamelCase(data);
}
